import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import responseActions from '../../redux/responseAction/actions';
import { Modal } from '../../components/modals/antd-modals';

const AlertResponse = () => {
  const dispatch = useDispatch();
  const [alert, setAlert] = useState(<></>);
  const responseStatus = useSelector(state => state.responseReducer.responseStatus);

  useEffect(() => {
    try {
      const alertBuild = error => {
        if (typeof error === 'string') {
          return (
            <li key={error} className="font-weight-normal">
              {error}
            </li>
          );
        } else if (Array.isArray(error)) {
          return error.map(data => alertBuild(data));
        } else if (typeof error === 'object') {
          return Object.keys(error).map(key => {
            return (
              <li key={key}>
                {key}
                <ul>{alertBuild(error[key])}</ul>
              </li>
            );
          });
        }
      };

      const closeAlert = () => {
        setAlert(<></>);
        dispatch(responseActions.cleanResponseStatus());
      };

      if (Object.entries(responseStatus).length > 0) {
        switch (responseStatus.status) {
          case 'success':
            setAlert(
              <Modal visible={true} onOk={closeAlert} footer={[<></>]}>
                <p>Saved Information</p>
              </Modal>,
            );
            break;
          case 'error':
            const { message } = responseStatus.response.data;
            let build = [];
            if (typeof message === 'object') {
              Object.keys(message).forEach((key, i) => {
                build.push(
                  <div key={'div' + i}>
                    <div>{key}</div>
                    <ul className="mb-2">{alertBuild(message[key])}</ul>
                  </div>,
                );
              });
            }

            setAlert(
              <Modal visible={true} onCancel={closeAlert} footer={[<></>]}>
                {build.length > 0 ? (
                  <div className="text-custome">
                    <div className="mb-4">The following field(s) has error:</div>
                    {build.map(el => el)}
                  </div>
                ) : (
                  message || 'Status response ' + responseStatus.response.status
                )}
              </Modal>,
            );
            break;
          default:
        }
      }
    } catch (e) {
      console.warn(e);
    }
  }, [responseStatus, dispatch]);

  return <>{alert}</>;
};

export default AlertResponse;
